<template>
    <v-card-text :class="`${secondColor}--text pb-0`" v-if="show && percent > 0">
        <div class="text-subtitle-1 font-weight-medium text-center mb-1">{{ Math.floor(percent) }}%</div>

        <div class="battery-bar">
            <v-progress-linear :value="percent" :color="secondColor" background-opacity="0.25" height="8" rounded :striped="isCharging" />
            <div class="battery-mark" title="80%" />
        </div>
        <div class="d-flex align-center justify-center text-caption text-no-wrap">
            <v-icon small :color="secondColor" class="mr-1">{{ batteryIcon }}</v-icon>
            Bateria
        </div>

        <div class="d-flex mt-2" v-if="rangeInKm || isCharging">
            <div class="half-col text-center">
                <div class="text-subtitle-1 font-weight-medium text-no-wrap">{{ rangeInKm ? `${rangeInKm} km` : "--" }}</div>
                <div class="d-flex align-center justify-center text-caption text-no-wrap">
                    <v-icon small :color="secondColor" class="mr-1">directions_car</v-icon>
                    Autonomia estimada
                </div>
            </div>
            <div class="half-col text-center" v-if="isCharging">
                <div class="text-subtitle-1 font-weight-medium text-no-wrap">{{ timeTo80Text }}</div>
                <div class="d-flex align-center justify-center text-caption text-no-wrap">
                    <v-icon small :color="secondColor" class="mr-1">timer</v-icon>
                    Para 80%
                </div>
            </div>
        </div>
    </v-card-text>
</template>

<script>
// Mesma estimativa do frontend_v2 (charging-card.tsx)
export default {
    props: {
        plug: {
            required: true,
        },
        secondColor: {
            required: true,
        },
        show: {
            required: true,
        },
    },

    computed: {
        percent() {
            return Number(this.plug.percent || 0);
        },
        isCharging() {
            return this.plug.status == "Charging";
        },
        batteryIcon() {
            if (this.isCharging) {
                return "battery_charging_full";
            }
            return this.percent >= 95 ? "battery_full" : "battery_std";
        },
        // Capacidade estimada da bateria em kWh: consumo / (%atual - %inicial)
        capacity() {
            const percentStart = Number(this.plug.percentStart || 0);
            const consumption = Number(this.plug.consumption || 0);
            if (percentStart > 0 && consumption > 0 && this.percent > percentStart) {
                return consumption / ((this.percent - percentStart) / 100);
            }
            return null;
        },
        rangeInKm() {
            if (!this.capacity) {
                return null;
            }
            // Eficiência média (km/kWh) pela categoria do veículo, estimada pela capacidade da bateria
            let efficiency = 4.8;
            if (this.capacity <= 32.07) {
                efficiency = 3;
            } else if (this.capacity <= 54.82) {
                efficiency = 6.3;
            } else if (this.capacity <= 71.72) {
                efficiency = 5.8;
            } else if (this.capacity <= 100) {
                efficiency = 5.2;
            }
            return Math.round(this.capacity * (this.percent / 100) * efficiency);
        },
        minutesTo80() {
            const powerKw = Number(this.plug.power || 0) / 1000;
            if (!this.capacity || powerKw <= 0 || this.percent >= 80) {
                return null;
            }
            return Math.round(((this.capacity * (0.8 - this.percent / 100)) / powerKw) * 60);
        },
        timeTo80Text() {
            if (!this.minutesTo80) {
                return "--";
            }
            if (this.minutesTo80 < 60) {
                return `${this.minutesTo80} min`;
            }
            const minutes = this.minutesTo80 % 60;
            return `${Math.floor(this.minutesTo80 / 60)}h ${String(minutes).padStart(2, "0")}min`;
        },
    },
}
</script>

<style scoped>
.half-col {
    flex: 1 1 0;
    min-width: 0;
}

.battery-bar {
    position: relative;
    margin-bottom: 4px;
}

.battery-mark {
    position: absolute;
    top: -3px;
    bottom: -3px;
    left: 80%;
    width: 2px;
    background-color: currentColor;
    opacity: 0.7;
}
</style>
